import { yupResolver } from "@hookform/resolvers/yup"
import { type Resolver, useForm } from "react-hook-form"
import { array, object, string } from "yup"
import type { IPreassignationForm } from "../types"
import { useTranslation } from "react-i18next"

export function usePreassignationForm(
  defaultValues?: Partial<IPreassignationForm>
) {
  const { t } = useTranslation()
  const schema = object({
    events: array()
      .of(string())
      .min(1, t("global.requiredField", { field: t("events.event") })),
  }).required()

  return useForm<IPreassignationForm>({
    resolver: yupResolver(schema) as unknown as Resolver<IPreassignationForm>,
    defaultValues,
  })
}
